import { gsap } from "gsap";
import Lenis from "lenis";

const SmoothPageScroll = () => {
  const lenis = new Lenis({
    lerp: 0.15,
    autoRaf: true,
    anchors: { offset: -120 }
  });

  lenis.on("stop", (e) => {
    //console.log(e);
  });
  
  return lenis;
};

export { SmoothPageScroll };
